import { createContext } from 'react';
import { SidebarMenuContainer } from './styled';
export const SidebarMenuContext = createContext(null);
export function SidebarMenu(props) {
    const { minimized = false, children, className, onToggle } = props;
    const toggleMinimized = () => {
        if (onToggle) {
            onToggle();
        }
    };
    const value = { minimized, toggleMinimized };
    return (<SidebarMenuContext.Provider value={value}>
      <SidebarMenuContainer $minimized={minimized} className={className}>
        {children}
      </SidebarMenuContainer>
    </SidebarMenuContext.Provider>);
}
